/** Tarjeta blanca v2 con encabezado y contenido (design.md §22.7). */
import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { MobileIcon } from './MobileIcon';

type SectionCardProps = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  onAction?: () => void;
  actionLabel?: string;
  children: ReactNode;
  className?: string;
};

export function SectionCard({
  title,
  subtitle,
  action,
  onAction,
  actionLabel = 'Más opciones',
  children,
  className,
}: SectionCardProps) {
  return (
    <section className={clsx('rounded-card bg-white p-4 shadow-card', className)}>
      <div className="mb-3 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <h2 title={title} className="truncate text-base font-semibold text-text-primary">{title}</h2>
          {subtitle && <p title={subtitle} className="mt-0.5 truncate text-xs text-text-secondary">{subtitle}</p>}
        </div>
        {action ?? (
          onAction && (
            <button
              type="button"
              onClick={onAction}
              aria-label={actionLabel}
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-text-tertiary transition-colors hover:bg-bg-tertiary"
            >
              <MobileIcon name="more_horiz" className="h-5 w-5" />
            </button>
          )
        )}
      </div>
      {children}
    </section>
  );
}
